import { useEffect, useState } from 'react';
// True while the mouse has not moved for `delay` ms: the caller hides the cursor then.
export const useIdleCursor = (delay = 3000) => {
    const [idle, setIdle] = useState(true);
    useEffect(() => {
        let timer = 0;
        const onMove = () => {
            setIdle(false);
            window.clearTimeout(timer);
            timer = window.setTimeout(() => setIdle(true), delay);
        };
        window.addEventListener('mousemove', onMove);
        window.addEventListener('mousedown', onMove);
        return () => {
            window.removeEventListener('mousemove', onMove);
            window.removeEventListener('mousedown', onMove);
            window.clearTimeout(timer);
        };
    }, [delay]);
    return idle;
};
